import * as React from "react";
const SvgFiRrSnowflake = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-snowflake_svg__a)">
      <path
        fill="#062147"
        d="m22.761 13.971-2.445.646a2.7 2.7 0 0 0-.98.492l-2.618-1.522a4.7 4.7 0 0 0 0-3.174l2.617-1.522c.29.23.624.397.981.492 0 0 2.617.68 2.7.68a1 1 0 0 0 .256-1.963l-2.444-.647a.715.715 0 0 1-.508-.873l.647-2.444a1 1 0 1 0-1.934-.512l-.646 2.444a2.7 2.7 0 0 0-.058 1.1l-2.616 1.516A4.98 4.98 0 0 0 13 7.1v-3c.345-.134.658-.339.92-.6l1.787-1.788A1.002 1.002 0 0 0 14.293.293l-1.788 1.788a.72.72 0 0 1-1.01 0L9.707.293a1 1 0 0 0-1.414 1.414L10.081 3.5c.262.261.575.466.92.6v3a4.98 4.98 0 0 0-2.714 1.584L5.671 7.162a2.7 2.7 0 0 0-.058-1.1L4.967 3.62a1 1 0 0 0-1.934.512l.647 2.444a.715.715 0 0 1-.508.873L.728 8.1a1 1 0 0 0 .254 1.966c.085 0 2.7-.679 2.7-.679.357-.095.691-.263.981-.492l2.617 1.522a4.7 4.7 0 0 0 0 3.174L4.665 15.11a2.7 2.7 0 0 0-.98-.492l-2.446-.646a1 1 0 0 0-.51 1.93l2.443.646a.715.715 0 0 1 .508.873l-.647 2.444a1 1 0 1 0 1.934.512l.646-2.444c.095-.359.115-.733.058-1.1l2.616-1.522A4.98 4.98 0 0 0 11 16.9v3a2.7 2.7 0 0 0-.919.6l-1.788 1.793a1 1 0 0 0 1.414 1.414L11.5 21.92a.72.72 0 0 1 1.01 0l1.788 1.788a1 1 0 0 0 1.414-1.414l-1.788-1.788A2.7 2.7 0 0 0 13 19.9v-3a4.98 4.98 0 0 0 2.713-1.583l2.616 1.522c-.057.367-.037.741.058 1.1l.646 2.444a1 1 0 0 0 1.934-.512l-.647-2.444a.715.715 0 0 1 .508-.873l2.444-.647a.999.999 0 1 0-.51-1.933zm-10.76 1.03A3 3 0 1 1 12 9a3 3 0 0 1 0 6"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-snowflake_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrSnowflake;
